<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {
        "num_cand": "U2FsdGVkX18pwuOQi7eaUpjN9n/kG5w52cAWlmGBIeg=",
        "cpf": "U2FsdGVkX1954d+kL8Qt2tbYNk+IH1krHmZ2QnxgaU0="
      }, {
        "num_cand": "U2FsdGVkX18rCnDfHgdYYVCCg0wb7KIX1BQwFNFXots=",
        "cpf": "U2FsdGVkX1+hXNf90eW3qkgKfmSgqnauW37Vyh7pWyo="
      }, {
        "num_cand": "U2FsdGVkX19T5AUQbwge8IBD2m3dugqMJtyzfaT0Eog=",
        "cpf": "U2FsdGVkX19nvwfkBEH3FyJQjXndneYbod6s5dIVvLY="
      }, {
        "num_cand": "U2FsdGVkX1+ekZFxt9d2jb+5kBmbeBVVFdiwBFshxmI=",
        "cpf": "U2FsdGVkX19JnSZFRu43p4YWBtmAYS+vliFLIMC1mFw="
      }, {
        "num_cand": "U2FsdGVkX18nyBSNBuXEBfcAPtoO0L2kfyB+UkxSwcg=",
        "cpf": "U2FsdGVkX18QaO8+TRibvfV6deQSUsyKQJkiZDDOAh4="
      }, {
        "num_cand": "U2FsdGVkX18rA5aEbtV1rglv1Moq2dXYPnNozPtRpzA=",
        "cpf": "U2FsdGVkX1+OYcif7xeTL/pc2HnnpK0aRCUWeZ6atss="
      }, {
        "num_cand": "U2FsdGVkX18Iog+NjhLR+Th9wo9ZIZNrr1mCOxzOFk0=",
        "cpf": "U2FsdGVkX1+CFaTqOvtuh+jqOhyo+DV7Xfeyv+7E8C4="
      }, {
        "num_cand": "U2FsdGVkX18bIh0rGWSmHy8VGCcq6MJghovm8P2ghFs=",
        "cpf": "U2FsdGVkX18llCzvaWDsuxwZ+i4frH1j2NkpYirixz0="
      }, {
        "num_cand": "U2FsdGVkX18AzM6+dwYfcSHaNfHRm2+LzFq77kNYF4U=",
        "cpf": "U2FsdGVkX18S0Ik4YUHUJgLOKhmlbc8lRy7AOZRT4iI="
      }, {
        "num_cand": "U2FsdGVkX18BUS/yjopDDwP1v6NaVXXzGfAo6tYt3JU=",
        "cpf": "U2FsdGVkX18Xa+YT16BuILZVnl9U2kzDr0wYczzLyoc="
      }, {
        "num_cand": "U2FsdGVkX19uAP/hY2us3HCNZeC5uBsv/NQK0UB/M+A=",
        "cpf": "U2FsdGVkX1/5Mys9FZ9R22hO9Uagi3wP/VKk0jGrDlo="
      }, {
        "num_cand": "U2FsdGVkX19sIJRvoD3lFEew6QQJ3SdAD9n2EijSDp4=",
        "cpf": "U2FsdGVkX1/HPu0DEC/Cp0jPRlpejHvxT0yPq0lYN20="
      }, {
        "num_cand": "U2FsdGVkX1+RGDo+/WiY6VL9dJe9o7I8q1Vs3E/0QdU=",
        "cpf": "U2FsdGVkX1/aZELldazPDdhJQuqs7xThuhP89X+r+p0="
      }, {
        "num_cand": "U2FsdGVkX189cAVypH+1oFskrV895T14vDxUuQ8daiw=",
        "cpf": "U2FsdGVkX1/abSt9ST81BilrSfB7HfBoZgiZw/dxuUk="
      }, {
        "num_cand": "U2FsdGVkX18Ny7+tR0BL8vNHqsanKV7aM7ROTal+sPg=",
        "cpf": "U2FsdGVkX18utmziYXeVk/SIdWUiIzDaMaPoZnBDkSw="
      }, {
        "num_cand": "U2FsdGVkX1+jdeKk86mujdISE6xg4ZmPRZ5CqRgsJ8k=",
        "cpf": "U2FsdGVkX1+FBEJVsyBjhHJMnE6pZjh1yH97L6gKAE0="
      }, {
        "num_cand": "U2FsdGVkX1/zogyVt93SPX1iw1vkmK4GmAZS8cVTDtY=",
        "cpf": "U2FsdGVkX1/un5mxzm61U1nhWoeJxMbPfJPsbwG83Gk="
      }, {
        "num_cand": "U2FsdGVkX1/HxJh98lhaD8evQU+g3fc2puKo7+WEK64=",
        "cpf": "U2FsdGVkX18f7r9IiLT+j9bCyuTIYJ5hbbXhKefMj3o="
      }, {
        "num_cand": "U2FsdGVkX18vOO/xFePf5NoXWK1ctnTXCIQjKep8T4k=",
        "cpf": "U2FsdGVkX1/K5xy7CcCWiO6yEcZ8CzPhPlfJt1GVPZs="
      }, {
        "num_cand": "U2FsdGVkX1+EXlX+w0XpUtpg7si7+lQvB9QHDrGsjBw=",
        "cpf": "U2FsdGVkX18SBHTWrFPZwMqbazRbX5kGHYMVCeR2KTA="
      }, {
        "num_cand": "U2FsdGVkX1/pFR7PAFITRtD+DzCXeRQwwyqDoL1gxIE=",
        "cpf": "U2FsdGVkX19A9WOJEdVoayI30SDDobbKUyxipHyf4/k="
      }, {
        "num_cand": "U2FsdGVkX18DUNys59Uxldtv6JYJ7E48xtXCBI9vsBs=",
        "cpf": "U2FsdGVkX1+P6kbHGjUEHkijRCY0KK7f2J6CX6dqpto="
      }, {
        "num_cand": "U2FsdGVkX1+gsc8D1V85Z78fmleg+f6YrxAbX77coMA=",
        "cpf": "U2FsdGVkX1/Gse5cst7wA65oN3umdNPQmqcI8Y9UKu4="
      }, {
        "num_cand": "U2FsdGVkX19Qn5MmLXHq40cMa5s4pdGiFs02T32mEQQ=",
        "cpf": "U2FsdGVkX19WIJ6oBt/TrxfJ3lyGqyYsZrxhjyfshqU="
      }, {
        "num_cand": "U2FsdGVkX18iNBxDABjO4MdaxYBY5qRXjVJHQ1SYqig=",
        "cpf": "U2FsdGVkX18r3mNSu5cyeNeBChQ6DHucPcGJcsspp3g="
      }, {
        "num_cand": "U2FsdGVkX1+be2fDB2f4jcNrW2X6ZdaA16KDVgwq8mM=",
        "cpf": "U2FsdGVkX1/aR/cM+3vM2rJ/Z6X/5miOpB3PvycK1ds="
      }, {
        "num_cand": "U2FsdGVkX19RKbKp5t/Ml+skmzfZpZjppYNew4MoOI0=",
        "cpf": "U2FsdGVkX1/cPRm4gkTyx8HTXqWBeNGmDajjOF1GfAU="
      }, {
        "num_cand": "U2FsdGVkX19qEazXShScVvtkWpO+LxlmZFlAQuQJq44=",
        "cpf": "U2FsdGVkX1+K+mLhTrqmfEsaXyrdN3Z1+/jdRr/abDY="
      }, {
        "num_cand": "U2FsdGVkX18sD1t5GZE4FpuTVOmRS226/MMg4Lf4Jmk=",
        "cpf": "U2FsdGVkX1+tTcn6rNb8Efi82NI0+1CVytEqyqFSYgc="
      }, {
        "num_cand": "U2FsdGVkX1+xKp2+5kly3xGoURoF9rz5FwG86lH1LLM=",
        "cpf": "U2FsdGVkX1/ITjpMiAhMH7KdsH0QX/T2y5xdoHwdd6Y="
      }, {
        "num_cand": "U2FsdGVkX19vZBZjOGYMgobnkHa9nSoGLKvTtarwpNk=",
        "cpf": "U2FsdGVkX1+gLfxUpCnpMcHOwaH1I4ZpXComMjgc58E="
      }, {
        "num_cand": "U2FsdGVkX19HAPzaV+VR7GksE2/OCU6mbiNt0iStzXw=",
        "cpf": "U2FsdGVkX1/4CbrSJoTakj6vqb/GMEBN4jF+dIJldek="
      }, {
        "num_cand": "U2FsdGVkX1+INA/L2ZrHKM1dvIdLFHbt8ijzZ4WyAk4=",
        "cpf": "U2FsdGVkX1+IMo0ulCH5aTv2Vnd8lVXg2Kpw+fhBfzQ="
      }, {
        "num_cand": "U2FsdGVkX1/1ygV7JHothL0fXTJfBmPEyYZyKGvsSP4=",
        "cpf": "U2FsdGVkX190qpRdwLSO1ErQWiVN6ItUZFGq/vKy59E="
      }, {
        "num_cand": "U2FsdGVkX1/2UKtLzCXCFveVE/5i1Nr5MxLHMvMtJeM=",
        "cpf": "U2FsdGVkX1/lWGOYeusiUHhgbniIk/W/bR6cjNflrbU="
      }, {
        "num_cand": "U2FsdGVkX1+rQ8xcTV51CwP3A7BX1I79OEI7TW2JZR8=",
        "cpf": "U2FsdGVkX18WuLq11htWYmSdNev9R+JK5DGnoCHymys="
      }, {
        "num_cand": "U2FsdGVkX18Yg+7LZJge/ovrRQjOn+aOS0R2Uh3kDgU=",
        "cpf": "U2FsdGVkX188knfNGmdYg0Ta0p6EUA5DX6thipTaV8w="
      }, {
        "num_cand": "U2FsdGVkX187okzkS+j5cTAXVT8MdkLV8XXN9tFQWRE=",
        "cpf": "U2FsdGVkX18jVx9qAF+02A/KpSUzRJRlbYK0yvQXKuU="
      }, {
        "num_cand": "U2FsdGVkX18FW5aGv8P22qYAl4g0+NPjAevuE5WmmGg=",
        "cpf": "U2FsdGVkX181mu+SXLO+LJMqHcrwObUPBC/UGuy+uSk="
      }, {
        "num_cand": "U2FsdGVkX1+i7Bi9sibHzAvTvocesn19nKLnMDqWSMo=",
        "cpf": "U2FsdGVkX1/eXVsxAYF9N68oQwtvLWdQHkGq/4DrrTg="
      }, {
        "num_cand": "U2FsdGVkX18IoB4VP/+WYpTzMRF9bbOHuxKclWCyFXo=",
        "cpf": "U2FsdGVkX1/6lzLwkwKtBQ6Abtcso16vffeY1SVmF6A="
      }, {
        "num_cand": "U2FsdGVkX18Q8fi8Kf31JlhiNmng6tQiD8ENDfk7+tQ=",
        "cpf": "U2FsdGVkX1+VRPQblrUlZdcfo2piF6TCIpzR3ZZ2q/4="
      }, {
        "num_cand": "U2FsdGVkX18GToEM5FseffFKEvfG7FJjpjLCNnful+k=",
        "cpf": "U2FsdGVkX187LP/OR0bJFER3kEsUti4eOHRB879ZuEg="
      }, {
        "num_cand": "U2FsdGVkX1+NCC+AJuuJSIV8V/5IpoeMATNQGZ7Bflo=",
        "cpf": "U2FsdGVkX1+UdePaq/xQOn4MCBJ2nQyvm0CulofKxPI="
      }, {
        "num_cand": "U2FsdGVkX18K6zm/TbCqHwZRKbQapO5Z5xq9AB6W/xo=",
        "cpf": "U2FsdGVkX19tseZCH2c9WfLO7vLaZXvn031SI/MlYsg="
      }, {
        "num_cand": "U2FsdGVkX18bO+QrWkZ481zYx5AZR8utDm1FS7NLGAs=",
        "cpf": "U2FsdGVkX18i16yIgdvt44lY01pmr6eaEYagfYrt5Ec="
      }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2207/2207_re_isen/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
